import {BaseWidgetSettings} from "./base-settings.type";

export type PinSettings = {
  pinColor: string;
  idColor: string;
  macColor: string;
} & BaseWidgetSettings;
